exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-745c481e!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/grid/QueueStatusComponent.vue
// module id = 914
// module chunks = 2